<template>
  <div class="dsf-database">
    <div class="db-item" v-for="tab in tabList" :key="tab.name">
      <h3 class="title">{{ tab.title }}</h3>
      <ul class="item-content">
        <li v-for="it in tab.tabItems" @click="openUrl(it.urlAddress)" :key="it.name">
          <div class="img-wrap">
            <dsfImage :src="it.imgUrl" :dUrl="it.imgUrl" />
          </div>
          <div class="name">{{ it.name }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfRegisterDatabase",
  ctrlCaption: "注册数据资源面板",
  mixins: [$mixins.control, $mixins.card],
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {
    console.log(this.tabList);
  },
  methods: {
    openUrl(path) {
      const query = this.$route.query;

      if (path) {
        path = this.$replace(path, this.local);
        this.$open({
          url: path,
          state: 2,
          params: query,
        });
        // this.$emit("hasOpenUrl", path);
        this.$dialog?.close();
      }
    },
  },
});
</script>
